var _style, _path, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTemplogoshort(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 33.9 26",
    style: {
      enableBackground: "new 0 0 33.9 26"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#615DFF;}\r\n\t.st1{fill:#3DD9EB;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M20.1,26c2.8,0,5-2.3,4.5-5c-0.3-1.7-0.8-3.4-1.4-5c-1.3-3.2-3.1-6-5.4-8.4C15.4,5.2,12.7,3.3,9.6,2 C8.1,1.3,6.6,0.8,5,0.5C2.3-0.1,0,2.2,0,5v16c0,2.8,2.2,5,5,5H20.1z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M13.7,26c-2.8,0-5-2.3-4.5-5c0.3-1.7,0.8-3.4,1.4-5c1.3-3.2,3.1-6,5.4-8.4s5.1-4.3,8.2-5.6 c1.5-0.6,3.1-1.1,4.7-1.5c2.7-0.6,5,1.7,5,4.5v16c0,2.8-2.2,5-5,5H13.7z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTemplogoshort);
export default __webpack_public_path__ + "static/media/templogoshort.3a351d60941d6d570d6094cd700f081c.svg";
export { ForwardRef as ReactComponent };